export const users = {
  admin: {
    title: "Users",
  },
  error: {
    loading: "Error loading users",
  },
  history: {
    title: "Users History",
    empty: "No users history found",
    id: "ID",
    client: "Client",
    affiliateId: "Affiliate ID",
    actions: "Actions",
    subscription: "Subscription",
  },
};
